import React from 'react';
import ReactDOM from 'react-dom';

import { datadogRum } from 'root/datadog/datadogRum';

import { getTrackingEnvironment } from './getTrackingEnvironment';
import { TrackingProvider } from './TrackingContext';
import TrackingIdentify from './TrackingIdentify';

export function InitTrackingIdentify() {
  return new Promise<string>((resolve) => {
    const trackerElement = document.createElement('div');
    trackerElement.style.visibility = 'collapse';
    document.body.appendChild(trackerElement);

    ReactDOM.render(
      <TrackingProvider
        configs={[{ name: 'product', environment: getTrackingEnvironment() }]}
        onInitError={(err) => datadogRum.addError(err, { context: 'tracking_module_init' })}
      >
        <TrackingIdentify />
      </TrackingProvider>,
      trackerElement,
      () => resolve('Render completed')
    );
  });
}
